import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import { useScripts } from '../hooks/useScripts';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

function Features() {
  useDocumentTitle('Features');
  useScripts();
  
  useEffect(() => {
    // Trigger animations when component mounts
    const triggerAnimations = () => {
      // Dispatch scroll event to trigger css3-animate-it library
      window.dispatchEvent(new Event('scroll'));
      
      // Also manually trigger animations for visible elements
      setTimeout(() => {
        const animatedElements = document.querySelectorAll('.animated');
        animatedElements.forEach((el) => {
          const rect = el.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
          if (isVisible) {
            const originalClasses = el.className;
            el.className = originalClasses.replace(/\banimated\b/g, '').trim();
            void el.offsetHeight; // Force reflow
            setTimeout(() => {
              el.className = originalClasses;
            }, 10);
          }
        });
      }, 100);
    };
    
    // Trigger immediately and after a short delay
    triggerAnimations();
    setTimeout(triggerAnimations, 200);
    setTimeout(triggerAnimations, 500);
  }, []);
  const features = [
    {
      icon: 'feature-encryption.svg',
      title: 'INVISIBLE ENCRYPTION',
      description: 'Every byte you send is wrapped in 256-bit AES encryption. On public Wi-Fi, at home, or on mobile — your passwords, messages, and browsing history stay hidden from everyone.',
      delay: 'delay-250'
    },
    {
      icon: 'feature-incognito.svg',
      title: 'TRUE INCOGNITO MODE',
      description: 'Your real IP vanishes the moment you connect. Browse from any location without leaving a trace — websites, advertisers, and data brokers see nothing but an anonymous connection.',
      delay: 'delay-500',
      center: true
    },
    {
      icon: 'feature-speed.svg',
      title: 'UNCOMPROMISING SPEED',
      description: 'Thanks to our technologies you can be sure you won\'t slow down. KeepSolid Wise improves user experience and internet speed. Plus our super fast VPN servers all over the world ensure the best connections speed.',
      delay: 'delay-750'
    },
    {
      icon: 'feature-unblock.svg',
      title: 'Unblock websites',
      description: 'Unblock YouTube, unblock Facebook, unblock Twitter or sites at school, the library, or your office with Incogninet. You can bypass filters and firewalls set by your network administrator to gain access to your favorite content.',
      delay: 'delay-750'
    },
    {
      icon: 'feature-ip.svg',
      title: 'Hide your IP address',
      description: 'The Internet is infested with spammers, snoopers, and hackers. They silently monitor your online activities and steal your sensitive data like credit card information and passwords when you least expect it. If you connect with Hotspot Shield enabled, you get a new US IP address to mask your actual IP address and surf the Internet anonymously.',
      delay: 'delay-750'
    },
    {
      icon: 'feature-malware.svg',
      title: 'Malware Protection',
      description: 'Incogninet will alert you if you visit sites that are known to contain malware, and then block the site. It detects and blocks more than 3.5 million malicious, phishing and spam sites from infecting your device',
      delay: 'delay-750'
    }
  ];

  return (
    <>
      <section className="bg-gray feature-grid-section animatedParent">
        <div className="container">
          <div id="Features" className="why-choose">
            <h2 className="title-head">Our Features</h2>
            <div className="row">
              {features.map((feature, index) => (
                <div key={index} className={`col-md-4 col-12 feature-item-col animated bounceInUp ${feature.delay}`}>
                  <div className={`inside ${feature.center ? 'center' : ''}`}>
                    <img
                      src={`/images/features/${feature.icon}`}
                      alt=""
                      className="feature-icon"
                      aria-hidden="true"
                    />
                    <a href="#">{feature.title}</a>
                    <p>{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Features;
